import { Content } from '../../types';

export const puLuongContent: Content = {
  title: 'פו לונג (Pu Luong) - שמורת טבע קסומה בצפון וייטנאם',
  imageUrl: '/images/vietnam/pu-luong/pu-luong-wide.jpeg',
  introduction:
    "פו לונג הינה שמורת טבע מרהיבה בצפון וייטנאם, הנמצאת כ-5 שעות נסיעה מהאנוי וכשעתיים נסיעה ממאי צ'או או מנין בין. השמורה משתרעת על פני כ-17,600 דונם ותוואי הנוף שלה מתאפיין בשני רכסי הרים גבוהים וביניהם עמק ירוק, בו שדות אורז מדורגים ונהרות שופעים. במקום ניתן למצוא יערות גשם טרופיים, מפלים, נחלים ומגוון רחב של חיות בר. זהו יעד אידיאלי למטיילים המחפשים חוויות טבע אותנטיות, הרחק מהמוני התיירים.",
  sections: [
    {
      title: 'אטרקציות מרכזיות ופעילויות מומלצות',
      type: 'list',
      content: [
        {
          subtitle: 'מפל Hieu',
          text: 'אחד המפלים היפים ביותר בפו לונג. המים הצלולים יוצרים בריכות טבעיות קסומות בהן ניתן לשחות וליהנות מסביבה טבעית מרגיעה.',
        },
        {
          subtitle: "רפטינג על נהר הצ'אם (Cham River)",
          text: 'חוויה מיוחדת הכוללת שיט ברפסודות במבוק מסורתיות בנהר החוצה את העמק. זו דרך מצוינת להתרשם מהנוף הירוק ומהשקט המופלא של האזור.',
        },
        {
          subtitle: 'ביקור במערות',
          text: 'האזור מציע מספר מערות נסתרות ויפות, כמו מערת Doi (מערת העטלפים) הממוקמת בתוך השמורה, שם ניתן לראות נטיפים מיוחדים ואווירה מסתורית.',
        },
        {
          subtitle: 'טרקים ונופים פנורמיים',
          text: 'אחד המסלולים המומלצים הוא המסלול לפסגת ההר הגבוה ביותר בשמורה, שממנו נשקף נוף עוצר נשימה של כל האזור. המסלול לוקח כ-6 שעות ומתאים לחובבי הליכה אתגרית.',
        },
        {
          subtitle: 'שדות האורז המדורגים',
          text: 'בעונות הגידול (מאי-יוני, ספטמבר-אוקטובר) ניתן לראות את הטרסות בשיא פריחתן, כשהן צבועות בירוק או בזהוב בהתאם לעונה.',
        },
        {
          subtitle: 'כפרי המיעוטים האתניים',
          text: 'בפו לונג חיים בני שבט ה-Tai ו-Thai הלבנים, השומרים על מסורתם העתיקה. ניתן לבקר בכפרים כמו באן היי (Ban Hieu) ובאן דון (Ban Don), לשוטט בין בתי הכלונסאות וללמוד על התרבות המקומית.',
        },
        {
          subtitle: 'רכיבה על אופניים',
          text: 'אופניים הם דרך נפלאה לחקור את השמורה. אפשר לשכור אופניים ולצאת לסיבוב בין הכפרים, שדות האורז והעמקים הפוריים.',
        },
        {
          subtitle: 'חקלאות מסורתית והתנסות מקומית',
          text: 'ניתן להשתתף בפעילויות חקלאיות עם המקומיים, כמו קציר אורז בעונה, הכנת אוכל מסורתי וטעימת יין אורז ביתי.',
        },
      ],
    },
    {
      title: 'אפשרויות לינה',
      type: 'list',
      content: [
        {
          subtitle: 'Pu Luong Retreat',
          text: 'ריזורט פופולרי עם בקתות עץ המשקיפות לנוף עוצר נשימה.',
        },
        {
          subtitle: 'Pu Luong Eco Garden',
          text: 'מקום אירוח ברמה גבוהה עם בריכת אינפיניטי הצופה לשדות האורז.',
        },
        {
          subtitle: 'Pu Luong Treehouse',
          text: 'חוויה ייחודית של לינה בבקתות עץ בין היערות.',
        },
        {
          subtitle: 'Homestays מקומיים',
          text: 'למי שמחפש חוויה אותנטית וזולה, ניתן להתארח בבתים של משפחות מקומיות בכפרים.',
        },
      ],
    },
    {
      title: 'איך מגיעים?',
      type: 'text',
      content:
        "ניתן להגיע באוטובוס או רכב פרטי מהאנוי, כאשר הנסיעה אורכת כ-4.5-5 שעות.\n\nאופציה נוספת, הינה לנסוע למאי צ'או או נין בין ולשלב ביקור בפו לונג כחלק מטיול מקיף בצפון וייטנאם.",
    },
    {
      title: 'מתי מומלץ להגיע?',
      type: 'text',
      content:
        'התקופה הטובה ביותר לטייל בפו לונג הינה בחודשים מאי-יוני (אז השדות ירוקים ורעננים) או ספטמבר-אוקטובר (עונת הקציר, אז הנוף נצבע בזהוב). חודשי החורף יכולים להיות קרירים יותר, אך עדיין נעימים לטיול.',
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        'בשורה התחתונה, פו לונג הינה פנינת טבע נסתרת שעדיין אינה מוצפת בתיירים ומציעה שילוב מושלם של נופים מרהיבים, תרבות אותנטית ושלווה כפרית. בין אם הינכם חובבי טבע, טרקים, תרבות מקומית או פשוט מחפשים מקום רגוע לנוח בו – שמורה הזו הינה יעד שאסור לפספס!',
    },
  ],
};
